import {merge} from 'lodash-es';
import {BaseOctopusConfig} from '../../../../base.octopus-config';
import {defaultApiURL} from '../../../../src/app/settings/verdinum';

const overrideConfig = {
    configuration: {
        http: {
            apiUrl: defaultApiURL,
        }
    },
    map: {
        homepage_lms: {
            type: 'http',
            useLanguage: false,
        },
    }
};

export const InclusiveOctopusConfig = merge({}, BaseOctopusConfig, overrideConfig);
